<div class="container">
    <div class="row">
        <div class="col-lg-4 col-md-6" *ngFor="let project of projectsData">
            <div class="single-project">
                <div class="project-image">
                    <img src="{{environment.ImageApiPath +'/'+ this.project?.attachment?.name}}" alt="{{project?.name}}">
                </div>
                <div class="image-hover">
                    <div class="text">
                        <h3>{{project.category?.name}}</h3>
                        <a routerLink="/projects-details/{{project.id}}" class="read-more">{{project.name}}</a>
                    </div>
                </div>
            </div>
        </div    >

    </div>
</div>
